import { render, staticRenderFns } from "./RegisterBusiness.vue?vue&type=template&id=b3222c68&"
import script from "./RegisterBusiness.vue?vue&type=script&lang=js&"
export * from "./RegisterBusiness.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBusiness.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports